import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMenuList, removeMenuList } from "../Redux/actions/settingsActions";

import { getAllMenus } from "adminApi/MenuManageApi/MenuManage";

const useFetchMenu = (moduleName) => {
  const dispatch = useDispatch();
  const menuList = useSelector((state) => state.menulist.menulist || []);
  const [loading, setLoading] = useState(false);

  const fetchMenu = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getAllMenus();

      if (response.data.success && response.data.data) {
        const rawData = response.data.data || [];
        if (rawData.length > 0) {
          dispatch(setMenuList(rawData));
        } else {
          dispatch(removeMenuList());
        }
      } else {
        console.error('Failed to fetch menu data:', response.data.error);
        dispatch(removeMenuList());
      }
    } catch (error) {
      console.error("Error fetching menu:", error);
      dispatch(removeMenuList());
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!menuList.length) {
      fetchMenu();
    }
  }, [menuList.length, fetchMenu]);

  const groupedMenu = menuList.reduce((acc, item) => {
    const module = String(item.module).toLowerCase();
    if (!acc[module]) {
      acc[module] = [];
    }
    acc[module].push(item);
    return acc;
  }, {});

  return {
    menu: groupedMenu[String(moduleName).toLowerCase()] || [],
    allMenusGrouped: groupedMenu,
    loading,
    refetch: fetchMenu
  };
};

export default useFetchMenu;
